// @flow

const getConfiguration = (props: any) => {
    return {
        visible: (props.data && props.data.type && props.data.type === 'DYNAMIC'),
    };
}
export default getConfiguration;